import { padding, width } from "@mui/system";

const styles = (theme) => ({
  containerComponente: {},
  containerPaper: {
    position: "relative",
    overflow: "hidden",
    padding: "20px",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    gap: 1,
    width: "100%",
  },
  boxLayout: {
    position: "absolute",
    bottom: 10,
    right: -60,
    width: 120,
    height: 120,

    opacity: 0.3,
    pointerEvents: "none",
    zIndex: 0,
    transform: "rotate(40deg)",
    borderRadius: "20px",
    display: "flex",
  },
  icon: {
    position: "absolute",
    bottom: 40,
    right: 5,
    fontSize: "45px",
  },
  titleCard: {
    fontWeight: "bold",
    fontSize: "15px",
  },
  linearProgress: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1,
  },
  valueCard: {
    fontWeight: "bold",
    fontSize: "20px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});

export default styles;
